import { useQuery } from "@tanstack/react-query";
import React from "react";
import { getAllComplains } from "../../services/adminService";
import { useSelector } from "react-redux";
import SecondaryLoader from "../SecondaryLoader/SecondaryLoader";
import UserAvatar from "../Avatar/UserAvatar";

const ComplainList = () => {
  const userId = useSelector((state) => state.auth.id);

  const {
    data: complainsData,
    isPending,
    error: complainsError,
  } = useQuery({
    queryKey: ["complains"],
    queryFn: () => getAllComplains(),
    enabled: !!userId, 
  });

  if (isPending) {
    return <SecondaryLoader />;
  }

  if (complainsError) {
    return (
      <div className="bg-white rounded-lg shadow-lg p-5 flex justify-center items-center">
        <p className="text-red-500 text-sm font-semibold">
          Error loading complains. Please try again.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-[4px] shadow-lg p-5 flex flex-col gap-4 w-full">
      <p className="text-dark-gray text-lg md:text-xl font-semibold">
        Complains
      </p>
      <hr className="border border-border-color -mx-5 min-w-full" />

      {complainsData.length > 0 ? (
        <div className="space-y-4">
          {complainsData.map((item, index) => (
            <div
              key={index}
              className={`flex flex-col sm:flex-row gap-4 sm:gap-6 items-start sm:items-center p-3 ${
                index < complainsData.length - 1
                  ? "border-b border-gray-200"
                  : ""
              }`}
            >
              <UserAvatar
                src={item.user?.profile?.profilePhoto || item.profilePhoto}
                alt={`${item.user?.profile?.firstName || ''} ${item.user?.profile?.lastName || ''}`}
              />
              <div className="flex flex-col sm:flex-row justify-between w-full">
                <div>
                  <p className="text-sm md:text-base font-semibold text-gray-900">
                    {`${item.user?.profile?.firstName || ''} ${item.user?.profile?.lastName || ''}`}
                  </p>
                  <p className="text-sm md:text-base font-semibold text-gray-900">
                    {item.subject}
                  </p>
                  <p
                    className="text-gray-600 text-sm"
                    dangerouslySetInnerHTML={{ __html: item.question }}
                  />
                </div>
                <p className="text-xs md:text-sm text-gray-500 mt-2 sm:mt-0 sm:ml-4">
                  {item.createdAt.split("T")[0]}
                </p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-gray-500 text-center py-4">
          No complaints have been submitted yet.
        </div>
      )}
    </div>
  );
};

export default ComplainList;
